<template>
    <div>
        <app-header>
            <template slot="left">
                <router-link to="/konto">
                    <img src="./../assets/images/prev.svg" alt="">
                </router-link>
            </template>
            <template slot="title">Januar 2018</template>
        </app-header>
        <div class="container" >
            <div class="row" id="list">
                <div class="col-1 list-top">
                    <img src="./../assets/images/konto-icon.svg">
                </div>
                <div class="col-11 list-top">
                    <div class="font-btn-small"> Transaktionen Verlauf</div>
                </div>
                <div class="col-1 list-body">
                    <div id="purple-line"></div>
                </div>
                <div class="col-11 list-body">
                    <app-list-konto-trans></app-list-konto-trans>
                </div>
            </div>
        </div>
        <app-nav></app-nav>
    </div>
</template>

<script>
  import Header from './../components/Header'
  import Nav from './../components/Nav'
  import ListKontoTrans from './../components/konto/ListKontoTrans'
  export default {
    components: {
      appHeader: Header,
      appNav: Nav,
      appListKontoTrans: ListKontoTrans
    }
  }
</script>

<style lang="scss" scoped>
    @import './../styles/app';
    .row {
        padding: 18px;
        border-bottom: 1px solid $color-list-border;
    }
    #list {
        height: 100%;
        .list-top {
            margin-bottom: 10px;
        }
        #purple-line {
            margin-left: 5px;
            height: 100%;
            border-left: 2px solid $color-primary;
        }
    }
</style>
